// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a5e6df5c","667":"f67e9649","977":"8ec17315"}[chunkId] + ".chunk.js";
};